import React, { useState } from 'react'

import DropDown, { DropDownProps } from '@/common/components/DropDown'
import useI18n, { Translation } from '@/common/hooks/useI18n'

import { Menu } from './styled'

export type MenuOption = {
  label: Translation
  value?: number | string | boolean | null
  onClick?: () => void
}

interface DropDownMenuProps {
  dropDownProps?: Omit<DropDownProps, 'children'>
  options: MenuOption[]
  value?: MenuOption['value']
  onChange?: (value: MenuOption['value']) => void
}

const DropDownMenu = ({
  dropDownProps,
  value,
  options,
  onChange,
}: DropDownMenuProps) => {
  const { t } = useI18n()
  const [visible, setVisible] = useState(false)

  const selectedOption = options.find(option => option.value === value)

  return (
    <DropDown
      label={selectedOption?.label}
      visible={visible}
      onVisibleChange={setVisible}
      {...dropDownProps}
    >
      <div className='py-8'>
        {options.map((option, index) => (
          <Menu
            key={`dropdown-menu-${option.value ?? index}`}
            $isSelected={option.value !== undefined && option.value === value}
            onClick={() => {
              option.onClick?.()
              onChange?.(option.value)
              setVisible(false)
            }}
          >
            {t(option.label)}
          </Menu>
        ))}
      </div>
    </DropDown>
  )
}

export default DropDownMenu
